exports.templateUrl = document.body.getAttribute('data-template-url')
exports.baseUrl = document.body.getAttribute('data-base-url')
